import styled from "styled-components";

export const Container = styled.div`
	background-color: #eaeaea;
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 0.5rem 0;
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 15px;
`;

export const ConfirmationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	font-size: 0.8rem;
	width: 100%;
	font-weight: normal;
	padding-top: 1rem;
`;

export const ConfirmationMessage = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	min-width: 0;
	font-weight: normal;
`;

export const ConfirmationTitle = styled.div`
	font-weight: bold;
	font-size: 1rem;
`;

export const AreaButtons = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;
